import React, { useEffect, useState } from "react";
import "./NoAccessPage.css";
import { AI_BASE_URL, OECCBB_API_BASE_URL, SILOS_ID } from "../../config";

const NoAccessPage = (token) => {
  const [ippProduct, setIppProduct] = useState(null);
  // Use SILOS_ID to get the collection id for "Manuel IPP 2025"
  const collection = SILOS_ID["Manuel IPP 2025"];

  useEffect(() => {
    if (!collection) return;

    fetch(
      `${AI_BASE_URL}/products?collection_id=${collection}&skip=0&limit=100`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token.token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setIppProduct(data[0]);
        } else {
          setIppProduct(data);
        }
      })
      .catch(() => setIppProduct(null));
  }, [collection, token]);

  return (
    <div className="no-access-page">
      <div className="no-access-container">
        <p className="error-message">
          Vous n'avez actuellement pas accès au chat IA!
        </p>

        <p className="access-intro">Pour obtenir l'accès, vous pouvez :</p>

        <div className="access-options">
          <div className="access-option">
            <div className="option-icon">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45768C17.623 10.1593 16.8604 10.6597 16 10.88"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h3>Devenir Membre de l'OECCBB</h3>
            <p>
              Rejoignez l'Ordre des Experts-Comptables et Comptables Brevetés de
              Belgique pour accéder à toutes nos ressources IA.
            </p>
            <button
              className="access-btn align-btn"
              onClick={() => {
                const url = `${OECCBB_API_BASE_URL}/fr/contributions?token=${token.token}`;
                window.open(url, "_blank", "noopener,noreferrer");
              }}
            >
              Devenir membre
            </button>
          </div>

          <div className="access-option">
            <div className="option-icon">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 7H15"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 11H15"
                  stroke="#4A90E2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h3>Acheter le Manuel IPP 25 IA</h3>
            <p>
              Obtenez un accès spécialisé à notre assistant IA pour les
              questions fiscales liées à l'IPP 25.
            </p>
            <button
              className="access-btn align-btn"
              disabled={!ippProduct || !ippProduct.selling_url}
              onClick={() => {
                if (ippProduct && ippProduct.selling_url) {
                  window.open(
                    ippProduct.selling_url,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }
              }}
            >
              Acheter maintenant
            </button>
          </div>
        </div>

        <div className="contact-section">
          <p>
            Contactez nous à :{" "}
            <a href="mailto:info@taxandmanagement.be" className="admin-link">
              info@taxandmanagement.be
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoAccessPage;
